module.exports = __webpack_public_path__ + "img/marshalling.24ee4c2a.jpg";